module.exports = __webpack_public_path__ + "media/wii-fit-trainer.c1a1bd21.wav";